import { useMutation, useQueryClient } from "@tanstack/react-query";
import { instance } from "api/apiBase";
import { formatPhone } from "shared/utils";
import {
  isCallerUnknown,
  UNKNOWN_CALLER_LABEL
} from "shared/utils/transferred-call";
import { Notification } from "../types";

type CallNotificationMetadata = Notification["metadata"];

export const callerUnknown = (metadata: CallNotificationMetadata): boolean =>
  isCallerUnknown(metadata.from_number, metadata.transferred_from_number);

export const callerLabel = (metadata: CallNotificationMetadata): string => {
  if (callerUnknown(metadata)) return UNKNOWN_CALLER_LABEL;
  const name = metadata.from_name?.trim();
  if (name) return name;
  if (metadata.from_number) return formatPhone(metadata.from_number);
  return "Unknown caller";
};

export const useMarkNotificationAsRead = () => {
  const queryClient = useQueryClient();
  const { mutate } = useMutation({
    mutationKey: ["NOTIFICATIONS", "MARK_AS_READ"],
    mutationFn: (ids: number[]) =>
      instance.post("/portal/v1/notifications/mark_as_read", { ids }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["NOTIFICATIONS"] });
      queryClient.invalidateQueries({
        queryKey: ["UNREAD_NOTIFICATIONS_COUNT"]
      });
      queryClient.invalidateQueries({
        queryKey: ["TOTAL_UNREAD_NOTIFICATIONS"]
      });
      queryClient.invalidateQueries({ queryKey: ["NEWEST_NOTIFICATIONS"] });
    }
  });
  return mutate;
};
